import * as React from 'react';
export const MRSvg = React.forwardRef(function MRSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#159570',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F4B32E',
        d: 'M11.464 4a4 4 0 1 1-6.929 0 3.5 3.5 0 1 0 6.929 0ZM7 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z',
      }),
    ),
  );
});
MRSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MR = {
  category: 'flag',
  colorable: false,
  name: 'MR',
  svg: MRSvg,
};
